import { FC, useState, useEffect } from 'react';

import { useAngularCallback } from 'utils/contexts/angular';
import { useExpansionContext } from 'utils/contexts/expansion';
import { AngularListSegmentContext } from './AngularListSegmentContext';
import { SHOW_INSIGHTS_DRAWER_CALLBACK_KEY } from '../constants';
import { ListDetailsAngular } from '../domain';

const isQueryEmpty = (listDetails?: ListDetailsAngular) => {
  if (!listDetails) {
    return true;
  }

  return !listDetails.emailListId && listDetails.searchQuery.searchQueries.length === 0;
};

export const AngularListSegmentContextProvider: FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  const [listDetails, captureListDetails] = useState<ListDetailsAngular>();
  const { expand } = useExpansionContext();

  useAngularCallback(SHOW_INSIGHTS_DRAWER_CALLBACK_KEY, captureListDetails);

  useEffect(() => {
    if (!isQueryEmpty(listDetails) && listDetails?.openIfClosed) {
      expand();
    }
  }, [listDetails]);

  return (
    <AngularListSegmentContext.Provider
      value={{
        listDetails,
      }}
    >
      {children}
    </AngularListSegmentContext.Provider>
  );
};
